"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InquireButtonField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@chakra-ui/react");
var hooks_1 = require("@chakra-ui/hooks");
var ModalInquire_1 = require("../../inquire/ModalInquire");
var InquireButtonField = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var buttonData = _a.buttonData;
    var color = ((_b = buttonData.style) === null || _b === void 0 ? void 0 : _b.color) ? buttonData.style.color : "white";
    var _j = (0, hooks_1.useDisclosure)(), isOpen = _j.isOpen, onOpen = _j.onOpen, onClose = _j.onClose;
    if ((_c = buttonData.style) === null || _c === void 0 ? void 0 : _c.backgroundColor)
        delete buttonData.style.backgroundColor;
    if ((_d = buttonData.style) === null || _d === void 0 ? void 0 : _d.color)
        delete buttonData.style.color;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Box, __assign({ width: "100%", className: "" + (buttonData.class ? buttonData.class : ""), textAlign: "center" }, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ css: buttonData.style, onClick: onOpen, mx: "auto", width: "100%", type: "button", color: color, size: "lg", paddingY: "5", fontSize: "1.6rem", height: "auto", whiteSpace: "normal", _hover: {
                        color: color,
                        backgroundColor: (_f = (_e = buttonData.style) === null || _e === void 0 ? void 0 : _e.backgroundColor) !== null && _f !== void 0 ? _f : "",
                        textDecoration: "none",
                        opacity: 0.7,
                    }, _active: {
                        color: color,
                        backgroundColor: (_h = (_g = buttonData.style) === null || _g === void 0 ? void 0 : _g.backgroundColor) !== null && _h !== void 0 ? _h : "",
                        opacity: 0.7,
                    } }, { children: buttonData.data.body }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(ModalInquire_1.ModalInquire, { isOpen: isOpen, onOpen: onOpen, onClose: onClose }, void 0)] }, void 0));
};
exports.InquireButtonField = InquireButtonField;
